(function () {
  function capitalize(s) {
    if (!s) return s;
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  }

  function getVisibleLabelText(label) {
    if (!label) return '';
    var clone = label.cloneNode(true);
    var hidden = clone.querySelectorAll('.visually-hidden, .sr-only, [hidden], [aria-hidden="true"]');
    hidden.forEach(function (h) { h.remove(); });
    return clone.textContent.trim();
  }

  function getSelectedColorText() {
    var scope = document.querySelector('variant-selects') || document.querySelector('product-info') || document;
    var fieldsets = scope.querySelectorAll('fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (legend && /farbe/i.test(legend.textContent)) {
        var checked = fieldsets[i].querySelector('input:checked');
        if (checked) {
          // Prefer the raw input value: it's the plain option value with no
          // screen-reader-only availability text ("ausverkauft ..."), unlike
          // the label, which may contain that hidden text in its textContent.
          var val = (checked.value || '').trim();
          if (!val) {
            var label = fieldsets[i].querySelector('label[for="' + checked.id + '"]');
            val = getVisibleLabelText(label);
          }
          val = val.replace(/\s*\(.*?\)\s*$/, '');
          return val.trim();
        }
        var select = fieldsets[i].querySelector('select');
        if (select && select.selectedIndex > -1) {
          return select.options[select.selectedIndex].textContent.trim();
        }
      }
    }
    var selects = scope.querySelectorAll('select');
    for (var j = 0; j < selects.length; j++) {
      var wrapper = selects[j].closest('.product-form__input');
      var lbl = wrapper ? wrapper.querySelector('label') : null;
      if (lbl && /farbe/i.test(lbl.textContent)) {
        return selects[j].options[selects[j].selectedIndex].textContent.trim();
      }
    }
    return null;
  }

  function looksLikeSaneColorValue(s) {
    // Safety net: a real color name is short and shouldn't contain
    // availability/status wording that can leak in from hidden a11y text.
    if (!s || s.length > 30) return false;
    if (/ausverkauft|verf(ü|u)gbar|nicht|variante|sold out|unavailable/i.test(s)) return false;
    return true;
  }

  function updateTitles() {
    var color = getSelectedColorText();
    if (!color || !looksLikeSaneColorValue(color)) return;
    var colorCap = capitalize(color);
    var titleEls = document.querySelectorAll('.product__title h1, .product__title h2');
    titleEls.forEach(function (el) {
      var base = el.getAttribute('data-base-title');
      if (base === null) {
        base = el.textContent.trim();
        el.setAttribute('data-base-title', base);
      }
      var target = base + ' - ' + colorCap;
      if (el.textContent.trim() !== target) {
        el.textContent = target;
      }
    });
  }

  var debounceTimer;
  function scheduleUpdate() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(updateTitles, 60);
  }

  function closestSafe(node, selector) {
    if (!node) return null;
    var el = node.nodeType === 1 ? node : node.parentElement;
    return el && el.closest ? el.closest(selector) : null;
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (!document.querySelector('.product__title')) return;

    updateTitles();

    document.addEventListener('change', scheduleUpdate);
    document.addEventListener('click', function (e) {
      if (closestSafe(e.target, 'variant-selects, .product-form__input, fieldset')) {
        scheduleUpdate();
      }
    });

    var container = document.querySelector('main') || document.body;
    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (m) {
        return closestSafe(m.target, '.product__title, variant-selects');
      });
      if (relevant) scheduleUpdate();
    });
    observer.observe(container, { childList: true, subtree: true });
  });
})();
